// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1dtYC","title":"Images45_title__YrjHY","images":"Images45_images__305UA"};